<template>
	<div class="ui segment m-toolbox">
		<h2 class="ui header">
			工具箱
			<div class="sub header">一些自己在用的小工具，顺带放了技能和接单信息</div>
		</h2>

		<el-tabs v-model="active">
			<el-tab-pane label="工具" name="tools">
				<ToolBox v-if="loaded.tools"/>
			</el-tab-pane>
			<el-tab-pane label="技能" name="skill">
				<SkillCard v-if="loaded.skill"/>
			</el-tab-pane>
			<el-tab-pane v-if="priceEnabled" label="预算参考" name="price">
				<PriceTable :groups="priceGroups" :disclaimer="priceDisclaimer" @go-lead="active = 'lead'"/>
			</el-tab-pane>
			<el-tab-pane label="说需求" name="lead">
				<LeadForm v-if="loaded.lead"/>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import ToolBox from './ToolBox'
	import SkillCard from './SkillCard'
	import PriceTable from './PriceTable'
	import LeadForm from './LeadForm'
	import {getPriceList} from '@/api/wxtools'

	export default {
		name: 'Tools',
		components: {ToolBox, SkillCard, PriceTable, LeadForm},
		data() {
			return {
				active: 'tools',
				// 切到哪个页签才创建哪个组件，避免一进页面就把四份数据全拉下来
				loaded: {tools: true, skill: false, price: false, lead: false},
				priceEnabled: false,
				priceGroups: [],
				priceDisclaimer: ''
			}
		},
		watch: {
			active(name) {
				this.loaded[name] = true
			}
		},
		created() {
			getPriceList().then((res) => {
				if (res.code === 200 && res.data && res.data.enabled) {
					this.priceEnabled = true
					this.priceGroups = res.data.groups || []
					this.priceDisclaimer = res.data.disclaimer || ''
				}
			}).catch(() => {
				// 后端不可用时不显示预算页签即可，不打扰访客
			})
		}
	}
</script>

<style scoped>
	.m-toolbox {
		padding: 2em !important;
	}

	.m-toolbox .ui.header {
		margin-bottom: 1em;
	}

	.m-toolbox .sub.header {
		font-size: 13px;
		font-weight: 400;
		color: rgba(0, 0, 0, .4);
		margin-top: 6px;
	}

	.m-toolbox >>> .el-tabs__item {
		font-size: 14px;
	}

	.m-toolbox >>> .el-tabs__nav-wrap::after {
		height: 1px;
	}

	@media screen and (max-width: 768px) {
		.m-toolbox {
			padding: 1.2em !important;
		}
	}
</style>
